import { render, staticRenderFns } from "./CambiarDatosPasoCuatro.vue?vue&type=template&id=2ea30f5b"
import script from "./CambiarDatosPasoCuatro.vue?vue&type=script&lang=js"
export * from "./CambiarDatosPasoCuatro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports